import Marquee from 'react-fast-marquee';

import React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';
import { useLocation } from '@reach/router';
import { extractLanguage, getStoryblokAlt } from '../../helpers/common';

const getStoryblokDimensions = (url) => {
  const [rawWidth, rawHeight] = url?.split('/')[5]?.split('x') || [];
  const width = Number.parseInt(rawWidth, 10);
  const height = Number.parseInt(rawHeight, 10);

  return {
    width: Number.isNaN(width) ? undefined : width,
    height: Number.isNaN(height) ? undefined : height,
  };
};

function ImageSlider({ blok }) {
  const gallery = blok.images || [];
  const mobileGallery = blok.mobileSliderImages || [];
  const location = useLocation();
  const currentLanguage = extractLanguage(location.pathname);
  const duration = blok.autoplay_speed || 60;

  return (
    <div {...storyblokEditable(blok)}>
      <div className="pt-8 pb-[100px] hidden md:block image-slider-override" style={{ '--slider-duration': `${duration}s` }}>
        <Marquee pauseOnClick autoFill>
          {gallery.map(({ filename, ...asset }, i) => (
            (() => {
              const { width, height } = getStoryblokDimensions(filename);
              return (
            <div
              className={
                      clsx(`inline-block ${filename}`, i > 0 ? 'ml-4' : '')
                    }
              style={{ height: '450px' }}
                    // eslint-disable-next-line react/no-array-index-key
              key={`gallery-loop-${i}-${filename}`}
            >
              <img
                className="bg-green-600 object-cover h-full"
                src={filename}
                alt={getStoryblokAlt(asset, currentLanguage === 'en' ? 'gallery imagee' : 'Galeriebild')}
                width={width}
                height={height}
                loading="lazy"
                decoding="async"
              />
            </div>
              );
            })()
          ))}
        </Marquee>
      </div>
      <div className="pt-8 pb-[100px] block md:hidden image-slider-override" style={{ '--slider-duration': `${duration}s` }}>
        <Marquee pauseOnClick autoFill>
          {mobileGallery.map(({ filename, ...asset }, i) => (
            (() => {
              const { width, height } = getStoryblokDimensions(filename);
              return (
            <div
              className={
                      clsx('inline-block', i > 0 ? 'ml-4' : '')
                    }
              style={{ height: '200px' }}
                    // eslint-disable-next-line react/no-array-index-key
              key={`gallery-loop-${i}`}
            >
              {filename && (
                <img
                  className="bg-green-600 max-h-[200px] md:object-none object-contain h-full"
                  src={filename}
                  alt={getStoryblokAlt(asset, currentLanguage === 'en' ? 'Reference logo' : 'Referenzlogo')}
                  width={width}
                  height={height}
                  loading="lazy"
                  decoding="async"
                />
              )}
            </div>
              );
            })()
          ))}
        </Marquee>
      </div>
    </div>
  );
}

export default ImageSlider;
